import { Bestellung } from "mangdto"
import BaseLogic from "../base_logic"

export default class DetailsLogic extends BaseLogic {
  bestellung: Bestellung = null

  init(window: Window) {
    this.bestellung = this.mainLogic.bestellung
    this.mainLogic.bestellungListeners.push(() => {
      this.bestellung = this.mainLogic.bestellung
    })
  }
}
